import Cookies from "js-cookie";

import { router } from "@/main";
import { nextCargoApi } from "@/store/apis/baseApi";
import { startAppListening } from "@/store/utils";

import { settingsSliceActions } from "../settings";
import { authSlice } from "./auth.slice";

startAppListening({
  matcher: authSlice.actions.logout.match,
  effect: ({ payload }, { dispatch, getState }) => {
    const store = getState();
    Cookies.remove("userTerm", { path: "/" });
    sessionStorage.clear();
    localStorage.clear();

    switch (payload) {
      case "driver":
        router.navigate({ to: "/app/login" });
        break;
      case "expedition":
        router.navigate({ to: "/expedicao/login" });
        break;
    }

    if (store.nextCargo) {
      dispatch(nextCargoApi.util.resetApiState());
      dispatch(settingsSliceActions.clearSettings());
    }
  }
});
